"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaQueryTemplate = exports.isDirectionalConfig = exports.isBreakpointConfig = void 0;
const _1 = require(".");
const types_1 = require("../types");
const breakpoints = Object.values(_1.Breakpoints);
/**
 * Compare if object is type of BreakpointsConfigType and its types is right
 * @param prop Object of T
 */
function isBreakpointConfig(prop) {
    return (typeof prop === 'object' &&
        Object.keys(prop).every(key => breakpoints.includes(key) || breakpoints.includes(parseInt(key, 10))));
}
exports.isBreakpointConfig = isBreakpointConfig;
/**
 * Compare if object is type of Directional and its types is right
 * It allows Breakpoint config or single type
 * @param prop
 */
function isDirectionalConfig(prop) {
    return (typeof prop === 'object' &&
        Object.keys(prop).every(key => types_1.directions.includes(key)));
}
exports.isDirectionalConfig = isDirectionalConfig;
/**
* Create mediaQueryString for selected breakpoint
* @param breakpoint
* @param styles
* @param result
*/
function mediaQueryTemplate(breakpoint, styles, result) {
    if (breakpoint === '0') {
        return `${styles}
			${result}`;
    }
    return `${result}
		@media (min-width: ${breakpoint}px) {
			${styles}
		}`;
}
exports.mediaQueryTemplate = mediaQueryTemplate;
